var rightImg = "/static/c8393c6ae8389a95.png";

export { rightImg as default };
//# sourceMappingURL=bg.png.js.map
